module.exports = __webpack_public_path__ + "Roboto-Bold.36b5bab58a18b9c92486.ttf";


//////////////////
// WEBPACK FOOTER
// /home/leonhard/Projekte/braungardt/angular/src/assets/font/Roboto-Bold.ttf
// module id = ../../../../../src/assets/font/Roboto-Bold.ttf
// module chunks = styles